module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-wrapper"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("所有留言")]), _vm._v(" "), (_vm.msgList.length != 0) ? _c('ul', {
    staticClass: "list-box"
  }, _vm._l((_vm.msgList), function(item) {
    return _c('li', {
      staticClass: "list-item clearfix",
      on: {
        "click": function($event) {
          return _vm.showBox(item.user_id, item)
        }
      }
    }, [_c('div', {
      staticClass: "left-box"
    }, [(_vm.users[item.user_id].user_logo.indexOf('?') == 0) ? _c('img', {
      attrs: {
        "width": "60",
        "height": "60",
        "src": require("../../../images/personal_center/avatar_default.png"),
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "width": "60",
        "height": "60",
        "src": _vm.users[item.user_id].user_logo,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-box"
    }, [_c('p', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(_vm.users[item.user_id].nick_name))]), _vm._v(" "), _c('div', {
      staticClass: "content clearfix"
    }, [_c('div', {
      staticClass: "msg-content"
    }, [_c('i', {
      staticClass: "icon icon-upload"
    }), _c('span', {
      staticClass: "message",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "msg-detail"
    }, [_c('span', {
      staticClass: "dialog-num"
    }, [_c('i', {
      staticClass: "icon icon-dialog"
    }), _c('span', [_vm._v(_vm._s(item.msg_cnt))])]), _vm._v(" "), _c('span', {
      staticClass: "last-time"
    }, [_c('i', {
      staticClass: "icon icon-clock"
    }), _c('span', [_vm._v(_vm._s(item.create_time))])])])])])])
  }), 0) : _c('div', {
    staticClass: "msg-empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/personal_center/work-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("当前没有留言消息")])]), _vm._v(" "), (_vm.page.totalPage > _vm.page.curPage) ? _c('button', {
    staticClass: "more",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.getMsgList(parseInt(_vm.page.curPage) + 1)
      }
    }
  }, [(!_vm.isLoading) ? _c('span', [_vm._v("加载更多")]) : _c('img', {
    attrs: {
      "src": require("../../../images/common/loading_2_24x24.gif"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('message-box', {
    attrs: {
      "msgItem": _vm.msgItem,
      "isBoxShow": _vm.isBoxShow,
      "uid": _vm.uid
    },
    on: {
      "closeBox": _vm.closeBox
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-46bb44ba!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/message/all_message.vue
// module id = Kh8q
// module chunks = 16